import React from "react";
import products from "../DemoData/demoData";
import "./ProductCategory.css";
import ProductCard from "../ProductCard/ProductCard";

const ProductCategory = () => {
  const categories = [...new Set(products.map((product) => product?.category))];

  return (
    <div className="product-category">
      {categories?.map((category) => (
        <div key={category} className="category-section">
          {/* Category Header */}
          <div className="category-header">
            <h2>{category}</h2>
            <span>See All</span>
          </div>

          {/* Category Products */}
          <div className="category-products">
            {products
              ?.filter((product) => product?.category === category)
              ?.map((product) => (
                <ProductCard key={product.id} product={product} />
              ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductCategory;
